import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Pradosham.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import city from '../../../city.json'



import axios from 'axios';



const deities = {
  lordShiva: {
    name: "Lord Shiva",
    significance: "Lord Shiva, also known as Mahadeva, is regarded as the destroyer and transformer in the Holy Trinity (Trimurti) of Hinduism, alongside Brahma the creator and Vishnu the preserver. He represents both asceticism and the source of creation.",
    mythology: "In Hindu scriptures, Lord Shiva is depicted as the supreme yogi, residing on Mount Kailash. He is associated with deep meditation, cosmic dance (Tandava), and the destruction of ignorance and illusion. Major legends include his role in consuming the poison (Halahala) during the churning of the ocean (Samudra Manthan), and his manifestation as Ardhanarishvara — half male and half female — symbolizing balance of energies.",
    symbols: [
      "Trident (Trishul) – representing creation, protection, and destruction",
      "Crescent Moon – symbolizing time and rejuvenation",
      "Third Eye – representing wisdom, insight, and the power to destroy evil",
      "Damru (drum) – symbolizing cosmic rhythm and sound",
      "Snake (Vasuki) – representing power over fear and death",
      "River Ganga – flowing from his hair, symbolizing purification and life"
    ],
    culturalAspect: "Lord Shiva is one of the most widely worshipped deities in Hinduism. Devotees celebrate Maha Shivaratri with great devotion, and temples like Kashi Vishwanath, Kedarnath, Somnath, and Amarnath are major centers of his worship. Shiva is revered in both Vedic and folk traditions as the source of ultimate liberation (Moksha)."
  }
};


const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};




const vratImageMap = {
  'Shani Pradosh Vrat': 'https://nonprod-media.webdunia.com/public_html/_media/hi/img/article/2020-07/17/full/1594986005-2417.jpg',
  'Ravi Pradosh Vrat': 'https://www.jagranimages.com/images/newimg/12092024/12_09_2024-ravi_pradosh_katha_23795742_1641371.jpg',
  'Bhauma Pradosh Vrat': 'https://wd-image.webdunia.com/image-conversion/process-aws.php?url=https://nonprod-media.webdunia.com/public_html/_media/hi/img/article/2017-05/22/full/1495452868-941.jpg&w=&h=&outtype=webp',
  'Budha Pradosh Vrat': 'https://images.timesnowhindi.com/photo/msid-99934004,thumbsize-59300,width-1280,height-720,resizemode-75/99934004.jpg',
  'Shukra Pradosh Vrat': 'https://prabhubhakti.net/wp-content/uploads/2023/07/Shukra-Pradosh-Vrat-Katha.jpg',
  'Soma Pradosh Vrat': 'https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/c0/a3/0d/c0a30d3d-7832-e3d1-b33b-4e3636c9e8e6/cover.jpg/1200x630bf-60.jpg',
  'Guru Pradosh Vrat': 'https://wd-image.webdunia.com/image-conversion/process-aws.php?url=https://nonprod-media.webdunia.com/public_html/_media/hi/img/article/2021-12/01/full/1638349908-7724.jpg&w=&h=&outtype=webp',
};








const Pradosham = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [pradList, setPradList] = useState([]);
  const [selectedPrad, setSelectedPrad] = useState(null);


  const [popupDeity, setPopupDeity] = useState(null);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };


  const pradoshamTooltips = {
  "Shani Pradosh Vrat": "Observed on a Saturday, Shani Pradosh Vrat is dedicated to Lord Shiva and Lord Shani. It is believed to remove obstacles, bad karma, and grant relief from Saturn’s influence.",
  "Ravi Pradosh Vrat": "Falling on a Sunday, Ravi Pradosh Vrat is observed to seek blessings of Lord Shiva and the Sun god. It is said to boost health, confidence, and cure ailments related to the eyes and soul.",
  "Bhauma Pradosh Vrat": "Held on a Tuesday, Bhauma Pradosh Vrat is observed for good health, strength, and protection from debts or legal issues. It is especially helpful for Mars-related doshas.",
  "Budha Pradosh Vrat": "This Wednesday observance is meant to strengthen intellect, communication skills, and decision-making. Devotees pray to Lord Shiva to remove Mercury-related afflictions.",
  "Shukra Pradosh Vrat": "Falling on a Friday, Shukra Pradosh is associated with prosperity, love, beauty, and happiness. It is believed to remove negative influences of Venus.",
  "Soma Pradosh Vrat": "Soma Pradosh occurs on a Monday and is especially sacred. Observing this vrat helps in mental peace, marital harmony, and spiritual growth.",
  "Guru Pradosh Vrat": "Held on a Thursday, Guru Pradosh Vrat is performed for wisdom, knowledge, and devotion. It’s believed to reduce Jupiter’s malefic effects and increase spiritual blessings."
};


useEffect(() => {
  const fetchPradData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/pradosham?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.pradoshamDays) {
        setPradList(response.data.pradoshamDays);
      } else {
        setPradList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch pradosham data:", error);
      setPradList([]);
    }
  };

  fetchPradData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED to refetch API
  setSuggestions([]);
};



  return (
    <div className="Pradosham-container">
      <InnerNav />
      <div className="Pradosham-content">
        <Zodiac />

        {/* Calendar Section */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Pradosham Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                 
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Prad-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedPrad ? (
  <div className="prad-list">
    {pradList.length === 0 && (
      <p>No pradosham data available for selected year/location.</p>
    )}

    {pradList.map((item, idx) => (
      <div
        className="prad-item clickable"
        key={idx}
        onClick={() => setSelectedPrad(item)}
      >
        <img
          src={
            vratImageMap[item.title] ||
            "https://www.hinduismoutlook.com/wp-content/uploads/2020/04/Pradosham.jpg"
          }
          alt={item.title}
        />

        <div className="prad-details">
          <p className="prad-date">{item.date}</p>
          <div className="prad-name">{item.title}</div>
          <p className="prad-phase">{item.muhurta}</p>
          <p className="prad-tithi">{item.tithiName}</p>
          <p className="prad-tithi">{item.duration}</p>
        </div>

        <div className="prad-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedPrad(null)}
    >
      ← Back
    </button>

    <h2>{selectedPrad.title}</h2>

    <img
      src={
        vratImageMap[selectedPrad.title] ||
        "https://www.hinduismoutlook.com/wp-content/uploads/2020/04/Pradosham.jpg"
      }
      alt={selectedPrad.title}
    />

    <p>
      {pradoshamTooltips[selectedPrad.title] ||
        "No information available"}
    </p>

    {(() => {
      const parts = selectedPrad.date.split(",");
      const month = parts[0]?.split(" ")[0];
      const day = parts[2]?.trim();

      return (
        <>
          <p><strong>Date:</strong> {selectedPrad.date}</p>
          <p><strong>Day:</strong> {day}</p>
          <p><strong>Month:</strong> {month}</p>
        </>
      );
      
    })()}
    <div className="detail-grid">

  <div><strong>Date:</strong> {selectedPrad.date}</div>

  <div><strong>Muhurta:</strong> {selectedPrad.muhurta}</div>

  <div><strong>Tithi:</strong> {selectedPrad.tithiName}</div>

  <div><strong>Duration:</strong> {selectedPrad.duration}</div>

  <div><strong>Lunar Detail:</strong> {selectedPrad.lunarDetail}</div>

  <div>
    <strong>Tithi Start:</strong>{" "}
    {formatTime(selectedPrad.tithiStart, timeFormat)}
  </div>

  <div>
    <strong>Tithi End:</strong>{" "}
    {formatTime(selectedPrad.tithiEnd, timeFormat)}
  </div>

</div>

  </div>
  
)}

        </div>

         <section className="pradosh-wrapper">
      <h1 className="pradosh-title">Pradosh Days or Pradosham Dates</h1>
      <div className="pradosh-texts">
        <p>
          <strong>Pradosh Vrat</strong>, which is also known as <strong>Pradosham</strong> in South India, is observed to seek blessings of 
          <span className="popup-link" onClick={() => setPopupDeity('lordShiva')}> Lord Shiva</span> 
          
          Pradosh Vrat is observed on both <strong>Trayodashi Tithis</strong>, i.e. <strong>Shukla Paksha Trayodashi</strong> and <strong>Krishna Paksha Trayodashi</strong>, in the lunar month. Some people distinguish between Shukla and Krishna Paksha Pradosham.
        </p>

        <p>
          When Pradosham day falls on <strong>Monday</strong> it is called <strong>Soma Pradosham</strong>, on <strong>Tuesday</strong> it is called <strong>Bhauma Pradosham</strong>, and on <strong>Saturday</strong> it is called <strong>Shani Pradosham</strong>.
        </p>

        <h2>Pradosh Vrat, Pradosham</h2>
        <p>
          For <strong>Pradosham Vrat</strong>, the day is fixed when <strong>Trayodashi Tithi</strong> falls during <strong>Pradosh Kaal</strong>, which starts after sunset. 
          The time window after sunset when Trayodashi Tithi and Pradosh time overlaps is auspicious for <strong>Shiva Puja</strong>. 
        </p>

        <h2>Location based Pradosham Days</h2>
        <p>
          It is important to understand that <strong>fasting day for Pradosham</strong> might differ for two cities even if those cities are within the same Indian state. 
          Fasting for Pradosham depends on <strong>sunset time</strong> and it is observed when <strong>Trayodashi Tithi</strong> prevails after sunset. 
          Hence Pradosham fasting might be observed on <strong>Dwadashi Tithi</strong>, i.e. one day before Trayodashi Tithi.
        </p>

        <p>
          As sunset time is different for all cities, it is important to refer to a Hindu calendar that lists <strong>location-based Pradosham days</strong>. 
          As generating location-based dates is time-consuming, most sources ignore this fact and publish a single list for all cities.
        </p>
      </div>
    </section>
        <VratLinks/>
      </div>
      <Footer />
            {popupDeity && (
  <div className="popup-overlay" onClick={() => setPopupDeity(null)}>
    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
      <h2>{deities[popupDeity].name}</h2>
      <p><strong>Significance:</strong> {deities[popupDeity].significance}</p>
      <p><strong>Mythology:</strong> {deities[popupDeity].mythology}</p>

      <h3>Symbols</h3>
      <ul>
        {deities[popupDeity].symbols.map((symbol, idx) => (
          <li key={idx}>{symbol}</li>
        ))}
      </ul>

      <p><strong>Cultural Aspect:</strong> {deities[popupDeity].culturalAspect}</p>

      <button className="close-btn" onClick={() => setPopupDeity(null)}>Close</button>
    </div>
  </div>
)}
    </div>
  );
};

export default Pradosham;
